import api from "@api";
import {log} from "@helpers";

const createMensagemContato = async (dadosContato) => {
  let {name, email, message, tokenRecaptcha} = dadosContato;

  const payload = {
    pathWithDomain: `${process.env.REACT_APP_API_V2}/suporte/publico`,
    method: "post",
    body: {
      mensagem: message,
      nome: name,
      email,
      recaptcha: tokenRecaptcha,
    },
  };
  log("Enviar mensagem de contato payload:", payload);

  return api(payload);
};

export default createMensagemContato;
